import script from "./MonthField.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonthField.vue?vue&type=script&setup=true&lang=ts"

import "./MonthField.vue?vue&type=style&index=0&id=80fde306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80fde306"]])

export default __exports__